import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { ToolBarMenu } from '@maced/angular-components/lib/navigation-drawer/toolbar/toolbar.model';
import { delay, first, of } from 'rxjs';

@Component({
  selector: 'app-navigation-drawer-with-sub-child',
  templateUrl: './navigation-drawer-with-sub-child.component.html'
})
export class NavigationDrawerWithSubChildComponent {
  isShowMenubar = false;
  isShowCascadebar = false;
  isShowToolbar = true;
  breadCrumbLimit: number = 20;
  public breadcrumbsName: any[] = [];

  toolbarMenuList: ToolBarMenu[] = [
    { id: 'Toolbar', name: 'Cursor', tooltip: 'Cursor', icon: 'icon-cursor', isDivider: true, disable: true, badge: 102 },
    { id: 'Selection', name: 'Selection', tooltip: 'Selection', icon: 'icon-selection' },
    { id: 'Pen', name: 'Pen', tooltip: 'Pen', toolmsg:'(mouse-only functionality)', icon: 'icon-pencil' },
    { id: 'Highlighter', name: 'Highlighter', tooltip: 'Highlighter', toolmsg:'(mouse-only functionality)', icon: 'icon-pencil-line' },
    { id: 'Text', name: 'Text', tooltip: 'Text', toolmsg:'(mouse-only functionality)', icon: 'icon-type' },
    { id: 'Mask', name: 'Mask', tooltip: 'Mask', icon: 'icon-mask', isDivider: true },
    { id: 'Save Progress', name: 'Save Progress', tooltip: 'Save Progress', icon: 'icon-save', isDivider: true },
    { id: 'Delete Selected', name: 'Delete Selected', tooltip: 'Delete Selected', icon: 'icon-trash' }
  ];
  menuList = [
    { id: 'Table Of Contents', name: 'Table Of Contents', icon: 'icon-bookshelf', trailingIcon: 'icon-chevron-right' },
    { id: 'Quick Links', name: 'Quick Links', icon: 'icon-cursor-click', trailingIcon: 'icon-chevron-right', disabled: true },
    { id: 'My Bookmarks', name: 'My Bookmarks', icon: 'icon-bookmark', trailingIcon: 'icon-chevron-right' },
    { id: 'My Notes', name: 'My Notes', icon: 'icon-notes', trailingIcon: 'icon-chevron-right' },
    { id: 'Extra Activities', name: 'Extra Activities', icon: 'icon-file-plus', trailingIcon: 'icon-chevron-right' },
    { id: 'All Activities', name: 'All Activities', icon: 'icon-file-plus', trailingIcon: 'icon-chevron-right' },
    { id: 'My Downloads', name: 'My Downloads', icon: 'icon-download', trailingIcon: 'icon-chevron-right' },
    { id: 'Read Aloud', name: 'Read Aloud', icon: 'icon-volume-max', trailingIcon: 'icon-chevron-right' }
  ];

  cascadeMenus: any[] = [];
  cascadeMenuList = [
    [     
      { id: 'Unit 1: Culture',ariaLabel: 'Unit 1: Culture', name: 'Unit 1: Culture',checked: false,
        subChild: [
        {
          id: 'Lesson 1 Vocabulary',
          name: 'Lesson 1 Vocabulary'},
        {
          id: 'Lesson 2 Grammar',
          name: 'Lesson 2 Grammar'},
        {
          id: 'Lesson 3 Pronounciation',
          name: 'Lesson 3 Pronounciation'}   
        ] },
      { id: 'Travel',ariaLabel: 'Unit 2: Travel', name: 'Unit 2: Travel',checked: false,
        subChild: [
        {
          id: 'Lesson 1 Writing',
          name: 'Lesson 1 Writing'},
        {
          id: 'Lesson2 Travel Grammar',
          name: 'Lesson 2 Travel Grammar'},
        {
          id: 'Lesson3 Travel Pronounciation',
          name: 'Lesson 3 Travel Pronounciation'}] },
      { id: 'Experiences',ariaLabel: 'Unit 3: Life Experiences', name: 'Unit 3: Life Experiences',checked: false,
        subChild: [
        {
          id: 'Lesson 1 Reading',
          name: 'Lesson 1 Reading'},
        {
          id: 'Lesson 2 Listening',
          name: 'Lesson 2 Listening'},
        {
          id: 'Lesson 3 Speaking',
          name: 'Lesson 3 Speaking'},] },
      { id: 'Unit 4: Past Events',ariaLabel: 'Unit 4: Past Events', name: 'Unit 4: Past Events',checked: false,
        subChild: [
        {
          id: 'Lesson1 Events Reading',
          name: 'Lesson1 Events Reading'},
        {
          id: 'Lesson2 Events Grammar',
          name: 'Lesson2 Events Grammar'},
        {
          id: 'Lesson3 Events Writing',
          name: 'Lesson3 Events Writing'}   
        ] },
    ]
  ];
  isLinksClickable: boolean = false;
  nextIconClass: string = 'icon-chevron-slash';
  numberOfLinksVisible = 3;
  breadcrumbsContainer: string = 'breadcrumbsContainer';
  toolbarHamburgerAriaLabel: string = 'Menu';
  hasMoreMenuButton=true;
  hasMultipleOptionClass=true;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateUIAsPerWindow();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: any) {
    let value: any
    if( document.getElementsByClassName('c-menu__list-item-link active').length !==0 ){
      value = document.getElementsByClassName('c-menu__list-item-link active');
    } else{
      value = document.getElementsByClassName('c-menu__list-item-link');
    }

    if(!this.isShowCascadebar){ 
      this.onCloseMenubar();
    }

    if (value) {
      let minvalue = (this.cascadeMenus.length > 1 )? 2 : this.cascadeMenus.length
      if (value.length > 2) {
        value[value.length - minvalue].focus();
      } else if(value.length === 2 && this.cascadeMenus.length !== value.length){
        value[value.length - 1].focus();
      } else {
        value[0].focus();
      }
      this.onClickCascadeBack(value.length);
    }   
  }
  constructor( @Inject(PLATFORM_ID) public platformId: Object) {
    if(isPlatformBrowser(platformId)){
      this.updateUIAsPerWindow();
    }
  }

  updateUIAsPerWindow() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023) {
      this.isShowMenubar = true;
      this.isShowToolbar = false;
    } else {
      this.isShowMenubar = false;
      this.isShowToolbar = true;
    }
  }

  onClickHamburger() {
    this.isShowCascadebar = false;
    this.isShowMenubar = !this.isShowMenubar;

    if (this.isShowMenubar) {
      this.toolbarHamburgerAriaLabel = 'Menu';
    } else {
      this.toolbarHamburgerAriaLabel = 'Menu'
    }

    this.toolbarMenuList.forEach((obj: any) => obj.active = false);
    if (!this.isShowMenubar) {
      this.menuList.forEach((obj: any) => obj.active = false);
    }
  }

  onClickToolMenu(menu: any) {
    this.toolbarMenuList.forEach((obj: any) => obj.active = false);
    this.toolbarMenuList.forEach((obj: any) => {
      if (obj.id === menu.id) {
        obj.active = true;
      }
      return obj;
    });
  }

  onCloseMenubar() {
    of('Observable To Update HTML').pipe(first(), delay(100)).subscribe(() => {
      this.isShowMenubar = false;
      this.menuList.forEach((obj: any) => obj.active = false);
      if (this.isShowMenubar) {
        this.toolbarHamburgerAriaLabel = 'Menu';
      } else {
        this.toolbarHamburgerAriaLabel = 'Menu';
        let menuBarButton: any = document.getElementsByClassName('c-navigation-tools__burger-button');
        if (menuBarButton.length > 0) {
          menuBarButton[0]?.focus();
        }
      }
    });
  }

  onClickMenu(menu: any) {
    this.cascadeMenus = [];
    this.breadcrumbsName = [];
    const windowWidth = window.innerWidth;
    if(!menu.disabled){
      if (windowWidth < 1023) {
        this.isShowCascadebar = true;
      } else {
        this.isShowMenubar = false;
        this.isShowCascadebar = true;
      }
  
      this.cascadeMenus.push({
        name: menu.name,
        isVisible: true,
        menus: this.cascadeMenuList[0]
      });
  
      this.menuList.forEach((obj: any) => {
        if (obj.id === menu.id) {
          obj.active = true;
        } else {
          obj.active = false;
        }
        return obj;
      });
    }

  }

  onClickMoreMenu() {
    this.onClickCascadeClose();
  }

  onClickCascadeMenu(menu: any, index: number) {
    if(!menu.disabled){
      this.cascadeMenus.splice(index + 1, this.cascadeMenus.length - (index + 1));

      if (menu.isContainSubMenu) {
        this.displayBreadcrumbs(menu);
        this.cascadeMenus.push({
          name: menu.name,
          isVisible: true,
          menus: this.cascadeMenuList[index + 1]
        });
      }
  
      this.cascadeMenus.forEach((parentObj: any, i: number) => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 1023) {
          if (i <= index && menu.isContainSubMenu) {
            parentObj.isVisible = false;
          }
        }
  
        if (i > index) {
          parentObj.menus.forEach((obj: any) => obj.active = false);
        } else if (i === index) {
          const updateActiveState = (item: any, targetId: string | number) => {
            item.active = item.id === targetId;
            if (item.subChild?.length) {
              item.subChild.forEach((child: any) => {
                updateActiveState(child, targetId);
                if (child.active) item.active = true;
              });
            }
          };
          parentObj.menus.forEach((obj: any) => updateActiveState(obj, menu.id));
        }
      });
    }
  }

  onClickCascadeBack(index: number) {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023) {
      this.cascadeMenus.splice(index, 1);
      this.breadcrumbsName.splice(index - 1, 1);
      this.numberOfLinksVisible = this.breadcrumbsName.length - 1
      if (this.cascadeMenus.length > 0) {
        this.cascadeMenus[this.cascadeMenus.length - 1].isVisible = true;
      }
    } else {
      this.cascadeMenus.splice(this.cascadeMenus.length - 1, 1);
    }
    if (this.cascadeMenus.length === 0) {
      this.onClickCascadeClose();
    }
  }

  onClickCascadeClose() {
    this.isShowCascadebar = false;
    this.isShowMenubar = true;
    this.cascadeMenuList.forEach((parentObj: any) => {
      parentObj.forEach((obj: any) => obj.active = false);
    });
    of('Observable To Update HTML').pipe(first(),delay(100)).subscribe(() => {
      let menuActiveList:any = document.getElementsByClassName('c-menu__list-item-link active');
      if(menuActiveList.length > 0){
        menuActiveList[0]?.focus();
      }
    })
  }

  hasTitleBar(index: number) {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023) {
      return true;
    } else if (index > 0) {
      return false;
    } else {
      return true;
    }
  }

  hasBreadcrumbs() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023 && this.breadcrumbsName.length) {
      return true;
    } else {
      return false;
    }
  }

  displayBreadcrumbs(menu: any) {
    if (menu && menu.name) {
      if (this.breadcrumbsName.length) {
        let breadcrumbsData = this.breadcrumbsName.find(data => data.name === menu.name);
        if (!breadcrumbsData) {
          this.breadcrumbsName.push({
            id: menu.id,
            name: menu.name,
            label: menu.name
          })
          this.numberOfLinksVisible = this.breadcrumbsName.length - 1
        }
      } else {
        this.breadcrumbsName.push({
          id: menu.id,
          name: menu.name,
          label: menu.name
        })
        this.numberOfLinksVisible = this.breadcrumbsName.length - 1
      }
    }
  }
}